import { createRouter, createWebHistory } from 'vue-router'

import mobileScanRoutes from './mobileScanRoutes'
import authRoutes from './authRoutes'
import generalRoutes from './generalRoutes'
import batchRoutes from './batchRoutes'
import inventoryAndListingsRoutes from './inventoryAndListingsRoutes'
import connectionRoutes from './connectionRoutes'
import orderRoutes from './orderRoutes'
import insightsRoutes from './insightsRoutes'

import { handleBeforeEach } from '@/helpers/routes'
import { carryHelpPage, fullPathWithoutHelp } from '@/helpers/helpHub'
import { trackInsightsViewed } from '@/helpers/insightsAnalytics'

const routes = [
  ...mobileScanRoutes,
  ...authRoutes,
  ...generalRoutes,
  ...batchRoutes,
  ...inventoryAndListingsRoutes,
  ...connectionRoutes,
  ...orderRoutes,
  ...insightsRoutes,
  // 404 not found page
  {
    path: '/:catchAll(.*)',
    name: 'NotFoundPage',
    component: () => import('@/views/NotFoundPage.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    // Only the Help Hub's page changed: the dealer's page stays where it was.
    if (fullPathWithoutHelp(to) === fullPathWithoutHelp(from)) return false
    // A hash names an element on the page (a changelog post); one not rendered yet is the page's to reach.
    const target = to.hash && document.getElementById(to.hash.slice(1))
    if (target) {
      target.scrollIntoView()
      return false
    }
    // Real scroll container is MainLayout's inner section, not window.
    const container = document.getElementById('main-content-scroll')
    if (container) container.scrollTop = 0
    return { top: 0 }
  },
})

router.beforeEach(carryHelpPage(router))
router.beforeEach(to => handleBeforeEach(to))
router.afterEach((to, from, failure) => { if (!failure) trackInsightsViewed(to, from) })

export default router
